/**
 * Tenant = the shape the Tenants UI components render. It is kept aligned with
 * `AdminTenant` (src/lib/superadmin.ts) so the page can map real API rows
 * straight onto it. Fields not provided by the API (`devices`, `kycStatus`)
 * are optional and only used by the detail modal when present.
 *
 * NOTE: the design-time sample `tenants` array was removed — the live page
 * loads real data via `tenants.list`. Only the type + the filter constants
 * below are used by the app.
 */
export interface Tenant {
  id: string;
  businessName: string;
  slug?: string;
  ownerName: string;
  email: string;
  phone: string;
  city: string;
  address: string;
  gstin: string;
  fssai: string;
  plan: "Starter" | "Professional" | "Enterprise" | "starter" | "growth" | "pro" | null;
  status: "active" | "trial" | "churned" | "suspended";
  outlets: number;
  signupDate: string;
  lastActive: string;
  monthlyRevenue: number;
  ordersPerDay: number;
  devices?: number;
  kycStatus?: "verified" | "pending" | "rejected";
}

// Filter dropdown values. `plans`/`statuses` match the API's verbatim values.
// TODO: drive `cities` from the live tenant list so it can't drift from real data.
export const cities = ["Mumbai", "Delhi", "Bangalore", "Hyderabad", "Chennai", "Pune", "Ahmedabad", "Kolkata"];
export const plans = ["starter", "growth", "pro"] as const;
export const planLabels: Record<string, string> = { starter: "Starter", growth: "Growth", pro: "Pro" };
export const statuses = ["active", "trial", "churned", "suspended"] as const;
